module.exports = __webpack_public_path__ + "static/media/CHAP01-GROSBILL-LOGO.65a36b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP01-GROSBILL-LOGO.png
// module id = 252
// module chunks = 0